// =============================================
// SERVICIO DE PAGOS
// Incluye funciones de abonos automáticos
// =============================================

import api from './api';

const paymentService = {
  // PAYMENTS: Obtener todos los pagos
  getAll: async () => {
    const response = await api.get('/payments');
    return response.data;
  },

  // PAYMENTS: Obtener pago por ID
  getById: async (id) => {
    const response = await api.get(`/payments/${id}`);
    return response.data;
  },

  // PAYMENTS: Crear nuevo pago (con archivo)
  create: async (paymentData) => {
    const formData = new FormData();
    
    formData.append('user_id', paymentData.user_id);
    formData.append('amount', paymentData.amount);
    formData.append('payment_date', paymentData.payment_date);
    formData.append('month', paymentData.month);
    formData.append('year', paymentData.year);
    
    if (paymentData.payment_proof) {
      formData.append('payment_proof', paymentData.payment_proof);
    }
    
    const response = await api.post('/payments', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // PAYMENTS: Actualizar pago
  update: async (id, paymentData) => {
    const formData = new FormData();
    
    if (paymentData.user_id !== undefined) {
      formData.append('user_id', paymentData.user_id);
    }
    if (paymentData.amount !== undefined) {
      formData.append('amount', paymentData.amount);
    }
    if (paymentData.payment_date !== undefined) {
      formData.append('payment_date', paymentData.payment_date);
    }
    if (paymentData.month !== undefined) {
      formData.append('month', paymentData.month);
    }
    if (paymentData.year !== undefined) {
      formData.append('year', paymentData.year);
    }
    
    if (paymentData.payment_proof) {
      formData.append('payment_proof', paymentData.payment_proof);
    }
    
    const response = await api.put(`/payments/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // PAYMENTS: Eliminar pago
  delete: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  },

  // DEPOSITS: Aplicar abono automático
  applyDeposit: async (depositData) => {
    const response = await api.post('/payments/apply-deposit', depositData);
    return response.data;
  },

  // DEPOSITS: Ver meses pendientes de un propietario
  getPendingMonths: async (userId) => {
    const response = await api.get(`/payments/pending/${userId}`);
    return response.data;
  },
};

export default paymentService;
